<script setup lang="ts">
  // Context
  import { useDiscoveryRootContext } from './DiscoveryRoot.vue'

  // Composables
  import { useDiscovery } from '@/composables/useDiscovery'

  // Utilities
  import { toRef } from 'vue'

  defineOptions({ name: 'DiscoveryPrev' })

  const { disabled } = defineProps<{ disabled?: boolean }>()

  const root = useDiscoveryRootContext('v0:discovery')
  const discovery = useDiscovery()

  const isDisabled = toRef(() => disabled || root.isFirst.value)

  function prev () {
    if (isDisabled.value) return
    root.prev()
  }
</script>

<template>
  <button
    v-if="!discovery.isInteractive.value"
    aria-label="Go to previous step"
    :disabled="isDisabled"
    type="button"
    @click="prev"
  >
    <slot :is-disabled />
  </button>
</template>
